import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1ea767e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = {
  key: 1,
  class: "container"
}
const _hoisted_3 = {
  class: "label-row",
  "data-testid": "fm-dash-responses-label-row"
}
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "responses" }

import DashboardCard from '@/components/FrontlineManagerDash/DashboardCard.vue'
import ProgressBar from '@/components/PrimeVue/ProgressBar.vue'
import { TimeOptionLabel } from '@/utils/time'
import { faEnvelopeOpen } from 'fontawesome/pro-regular-svg-icons'
import ResponsesSummaryLoading from '@/components/FrontlineManagerDash/ResponsesSummaryLoading.vue'

interface ResponsesSummary {
    label: string
    value: number
    responses: number
}

interface Props {
    summaries: ResponsesSummary[]
    timeFilter: TimeOptionLabel
    loading: boolean
    responseCount: number
    showError?: boolean
    onReloadClick?: Function
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsesSummary',
  props: {
    summaries: {},
    timeFilter: {},
    loading: { type: Boolean },
    responseCount: {},
    showError: { type: Boolean },
    onReloadClick: { type: Function }
  },
  setup(__props: any) {

const props = __props

const viewResponses = () => {
    window.location.href = `/responses/${props.timeFilter.time_unit}/${props.timeFilter.time_value}`
}

const getBarColor = (label: string) => {
    switch (label) {
        case 'promoter':
            return '{success.400}'
        case 'passive':
            return '{gray.400}'
        case 'detractor':
        default:
            return '{error.300}'
    }
}

const formatResponseCount = (count: number) => {
    const formattedCount = count.toLocaleString()
    return `(${formattedCount} ${count === 1 ? 'response' : 'responses'})`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DashboardCard, {
    class: "card",
    icon: _unref(faEnvelopeOpen),
    title: "Responses",
    "response-count": props.responseCount,
    "action-label": "Response details",
    "on-action-click": viewResponses,
    "show-error": _ctx.showError,
    "on-reload-click": _ctx.onReloadClick
  }, {
    content: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(ResponsesSummaryLoading)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.summaries, (summary, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "summary"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(summary.label) + "s ", 1),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(summary.value || 0) + "% ", 1),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(formatResponseCount(summary.responses || 0)), 1)
                ]),
                _createVNode(ProgressBar, {
                  value: summary.value,
                  "show-value": false,
                  "bar-color": getBarColor(summary.label)
                }, null, 8, ["value", "bar-color"])
              ]))
            }), 128))
          ]))
    ]),
    _: 1
  }, 8, ["icon", "response-count", "show-error", "on-reload-click"]))
}
}

})